<template lang="pug">
.high-res-clipboard-images
  div
    img(v-for="src in images", :src="src", @load="loaded(src)")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
// let loadTimer;
export default {
  name: 'high-res-clipboard-images',
  computed: {
    ...mapGetters(['clipboardItems']),
    ...vuexComputed('loadingImages'),
    images() {
      // const reg = /^img\:/;
      const reg = /img\:https\:\/\/content\.weave\.ai\/picture\-images\/(.+)\-(\d+).png/;
      return this.clipboardItems
        .filter(({ text }) => reg.test(text))
        .map(({ text }) => {
          const [did, pgn] = text.replace(reg, '$1|$2').split('|');
          return `https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ did }&page=${ pgn }`;
        });
    }
  },
  methods: {
    ...mapActions(['setLoaded']),
    loaded(src) {
      const {
        loadingImages,
        setLoaded
      } = this;
      console.log('loaded', src);
      if (loadingImages[src] !== 'loaded') {
        //console.log('handle loaded clipboard image');
        //clearTimeout(loadTimer);
        setLoaded(src);
        //loadTimer = setTimeout(() => copyDom(container, { clearSelect: true }));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/global';
.high-res-clipboard-images {
  position: fixed;
  top: 0;
  left: 0;
  transform: translate3d(-500vw, 0, 0);
  img {
    height: 700px;
    margin: 0.75rem;
  }
}
</style>